import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/documentation/network-whitelisting')({
  beforeLoad: () => {
    throw redirect({ to: '/network-connectivity-requirements' });
  },
});
